import '@iframe-resizer/child';

import Head from 'next/head';
import type { ReactElement } from 'react';

import { RetailerWidget } from '@/components/RetailerWidget/RetailerWidget';
import { RetailerLayout } from '@/layouts/RetailerLayout/RetailerLayout';
import { RetailerPageProvider } from '@/providers/RetailerPageProvider/RetailerPageProviderContext';

import * as S from './RetailerWidgetView.styles';

interface RetailerWidgetViewProps {
  locale?: string;
  multiDoors?: string[] | null;
  retailerId: string;
}

export const RetailerWidgetView = ({
  locale = 'us-en',
  multiDoors,
  retailerId,
}: RetailerWidgetViewProps) => {
  return (
    <>
      <Head>
        <title>Breitling Retailer</title>
        <meta content='width=device-width, initial-scale=1' name='viewport' />
        <link href='/favicon.ico' rel='icon' />
        <style>
          {`
            html {
              overflow: auto;
              scrollbar-width: none;
              -ms-overflow-style: none;
            }
          `}
        </style>
      </Head>

      <S.Container>
        <RetailerWidget
          locale={locale}
          multiDoors={multiDoors}
          retailerId={retailerId}
        />
      </S.Container>
    </>
  );
};

RetailerWidgetView.getLayout = (page: ReactElement) => {
  return (
    <RetailerPageProvider initialPage={page.props.initialTab}>
      <RetailerLayout cmsData={page.props.cmsDefaultLayoutData}>
        {page}
      </RetailerLayout>
    </RetailerPageProvider>
  );
};
